import { useState } from 'react'
import useMemberships from '../../../hooks/use-memberships'
import Image from '../../../components/image'
import TooltipIcon from '../../../components/svg/tooltip-icon'
import MembershipModal from '../modals/membership-info-modal'
import { Tooltip as ReactTooltip } from 'react-tooltip'

export default function MembershipInfo() {
  const [memberships] = useMemberships([])
  const [isMembershipBenefitModalOpen, setIsMembershipBenefitModalOpen] = useState(false)
  const [membership, setMembership] = useState(null)

  const handleViewBenefitsClick = (membership) => {
    setMembership(membership)
    setIsMembershipBenefitModalOpen(true)
  }

  if (memberships?.memberships?.length === 0) return null

  return (
    <div className='root'>
      {isMembershipBenefitModalOpen && (
        <MembershipModal
          onClose={() => setIsMembershipBenefitModalOpen(false)}
          membership={membership}
        />
      )}
      {memberships?.memberships?.map((data) => {
        return (
          <div key={data.programId} className='membership-info flex justifyBetween alignCenter'>
            <div className='root flex alignCenter'>
              <div className='logo'>
                {data?.programLogo ? (
                  <Image
                    src={data.programLogo}
                    alt={data.programName}
                    width='140'
                    height='37'
                    folder='benefitsProgramLogoImages'
                  />
                ) : null}
              </div>
              <div
                className='tooltip'
                data-tip
                data-for={`membershipInfoToolTip-${data.programId}`}
              >
                <TooltipIcon width={20} height={20} style={{ marginRight: 10 }} />
              </div>
              <ReactTooltip
                id={`membershipInfoToolTip-${data.programId}`}
                place='right'
                effect='float'
                type='light'
                className='membershipInfoToolTip'
              >
                This Vehicle belongs to a Dealer Membership Program, that gives benefits to members
                of {data.programName}
              </ReactTooltip>
            </div>
            <div className='root flex alignCenter justifyBetween description'>
              <button
                onClick={() => handleViewBenefitsClick(data)}
                className='flatBtn viewBenefitsBtn'
              >
                Click to view Benefits
              </button>
            </div>
          </div>
        )
      })}
      <style jsx>{`
        .description {
          font-size: 1.4rem;

          .viewBenefitsBtn {
            margin: 0.3rem 0 0;
            color: var(--text-link-color);
          }
        }

        .root {
          :global(.membershipInfoToolTip) {
            max-width: 50rem;
            font-size: 1.3rem;
            font-weight: 600;
            padding: 1rem 1.5rem;
            line-height: 2rem;
            border-radius: 1rem;
            opacity: 100;
            box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.16);
          }
        }

        @media (max-width: 1024px) {
          .description {
            font-size: 1.2rem;
          }
          .logo {
            :global(img) {
              width: 12rem;
              height: 3.5rem;
            }
          }
          .root {
            :global(.membershipInfoToolTip) {
              max-width: 35rem;
              font-size: 1.1rem;
            }
          }
        }

        @media (max-width: 400px) {
          .root {
            :global(.membershipInfoToolTip) {
              left: 5px !important;
              max-width: 30rem;
              font-size: 1rem;
              line-height: 1.5rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
